module.exports = __webpack_public_path__ + "static/media/texture (33).63d359dc.jpg";